import { useState, useEffect } from 'react';
import { ApiLocation } from '../../services/api';
import { ExternalLink } from 'lucide-react';

type BuoyDetailsProps = {
    location:  ApiLocation;
}

const CREST_URL = "https://crestcache.fiu.edu/research/research-buoys/";
const BUOYDATA_URL = "https://cloud.xylem.com/hydrosphere/public-sites?tab=1&customerId=OWA_D4FCEA1762484701A8D1891297DA823F&siteId="

export default function BuoyDetails({location}: BuoyDetailsProps) {
    return (
        <div className='p-6'>
            <div className="space-y-6  p-6 pt-4">
                <div className="">
                    <h2 className="text-4xl font-bold text-buoy">{location.siteName}</h2>
                    <p className="text-sm text-[#5D5346] py-5">{location.siteDescription}</p>  
                    <button
                        className="mt-1 flex items-center justify-center px-4 py-2 bg-buoy text-white border-2 border-buoy rounded-full text-sm font-medium hover:bg-buoy/80 shadow-sm transition-colors"
                        onClick={ () => window.open(`${BUOYDATA_URL + location.ID}`, "_blank", "noopener,noreferrer")
}
                    >
                        <div className='flex gap-3 items-center justify-center text-center'>
                            <p className='font-semibold text-sm'>Data Table</p>
                            <ExternalLink className='size-4'/>
                        </div> 
                    </button>     
                    <button
                        className="mt-3 flex items-center justify-center px-4 py-2 bg-white text-buoy border-2 border-buoy rounded-full text-sm font-medium hover:bg-gray-100 shadow-sm transition-colors"
                        onClick={ () => window.open(`${CREST_URL}`, "_blank", "noopener,noreferrer")
}
                    >
                        <div className='flex gap-3 items-center justify-center text-center'>
                            <p className='font-semibold text-sm'>About FIU Research Buoys</p>
                            <ExternalLink className='size-4'/>
                        </div> 
                    </button>                                
                </div>
            </div>

        </div>
    )
}